import { getContentApiUrl } from '@helsenorge/framework-utils/cms-content-api-service';
const fetchUtility = (url, options) => {
    return fetch(url, options).then((response) => {
        if (!response.ok)
            throw new Error(response.statusText);
        if (response.status === 204)
            return null;
        return response.json();
    });
};
export const sendUserFeedback = (pageId, contentWasRelevant, userFeedback = '') => fetchUtility(`${getContentApiUrl()}/api/userfeedback`, {
    method: 'POST',
    body: JSON.stringify({
        contentId: pageId,
        comment: userFeedback,
        contentWasRelevant: contentWasRelevant,
    }),
    headers: {
        'Content-Type': 'application/json',
    },
});
